// extracted by mini-css-extract-plugin
export default {"app":"NoticeBar_app__cc1xY","time":"NoticeBar_time__bCl2a","button":"NoticeBar_button__gq+bS"};